<template>
  <d-col cols="12" class="pl-0 pr-0">
    <label for="connected">
      {{ $t('order.connected.addRelatedOrders') }}:
    </label>

    <div class="d-flex">
      <div :class="{ 'form-control': true, 'is-select': true }">
        <v-select
          :options="connectedOrdersFiltered"
          v-model="selectedOrder"
          :filterBy="filterByForOrders"
          :disabled="!loadedConnectedOrders"
          :placeholder="$t('order.connected.selectRelatedOrder')"
          label="order_name"
          @search="debouncedFetchConnectedOrders">
          <template slot="no-options">
            <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
            <template v-if="emptyResults">{{ $t('order.connected.noOrdersToAssociate') }}&hellip;</template>
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.order_name }} (#{{ option.id }})
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.order_name }} (#{{ option.id }})
            </div>
          </template>
        </v-select>
      </div>

      <d-button
        v-if="selectedOrder"
        @click.prevent="addConnectedOrder"
        class="w-25 ml-2">
        {{ $t('order.connected.addRelation') }}
      </d-button>
    </div>
  </d-col>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';
import OrderStatusPhase from './../../data/order-status-phase.js';

export default {
  name: 'order-select-connected-orders',
  props: [
    'customer_id'
  ],
  computed: {
    connectedOrdersFiltered () {
      if (this.connectedOrders && this.connectedOrders.data) {
        return this.connectedOrders.data.filter(order => order.id !== parseInt(this.$route.params.id, 10));
      }

      return [];
    }
  },
  data () {
    return {
      selectedOrder: '',
      loadedConnectedOrders: false,
      connectedOrders: [],
      loadError: false,
      emptyResults: false
    }
  },
  watch: {
    'customer_id': function () {
      this.loadedConnectedOrders = false;
      this.loadConnectedOrders();
    }
  },
  mounted () {
    this.loadConnectedOrders();
  },
  methods: {
    loadConnectedOrders () {
      if (!this.customer_id) {
        return;
      }

      let whereData = {
        customer_id: this.customer_id,
        status: OrderStatusPhase.able_to_connect
      };

      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/items',
        loadedKey: 'loadedConnectedOrders',
        outputKey: 'connectedOrders',
        errorKey: 'loadError',
        overrideID: 0,
        method: 'get',
        params: {
          show_all: 1,
          where: whereData
        },
        noPagination: true
      });
    },
    filterByForOrders (option, label, search) {
      return (option.order_name + ' ' + option.id).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    // eslint-disable-next-line
    debouncedFetchConnectedOrders: debounce(function (searchPhrase, loadingCallback) {
      this.fetchConnectedOrders(searchPhrase, loadingCallback);
    }, 500),
    fetchConnectedOrders (searchPhrase, loadingCallback) {
      if (!this.customer_id) {
        return;
      }

      loadingCallback(true);
      this.emptyResults = false;
      let whereData = {
        customer_id: this.customer_id,
        status: OrderStatusPhase.able_to_connect
      };

      if (searchPhrase !== '') {
        whereData.order_name = searchPhrase;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/items',
        outputKey: 'connectedOrders',
        loadedKey: 'loadedConnectedOrders',
        errorKey: 'loadError',
        method: 'get',
        params: {
          show_all: 1,
          where: whereData
        },
        overrideID: 0,
        noPagination: true,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    addConnectedOrder () {
      this.$bus.$emit('connected-orders-add', {
        id: this.selectedOrder.id,
        status: this.selectedOrder.status,
        order_name: this.selectedOrder.order_name
      });

      this.selectedOrder = null;
    }
  }
}
</script>
